import React from 'react'
// libs
import styled from 'styled-components'
// constants
import { Modals } from 'constants/index'
// context
import { PowerBIReportsAPIContext } from 'containers/PowerBIReports/layers/API'
// components
import { Modal } from 'components/UI'
import ReportForm from './Form'
// hooks
import { useModalData } from 'hooks/index'
// themes
import { colors } from 'themes/index'
import { CloseIcon } from 'components/UI/Icons'

// styled
const Header = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.blue500};
  color: ${colors.blue500};
  display: flex;
  font-size: 16px;
  font-weight: bold;
  height: 32px;
  justify-content: space-between;
  margin-bottom: 16px;
  position: relative;
`

const MODAL_PROPS = {
  disableBackdropClick: true,
  disableEscapeKeyDown: true,
  disableRestoreFocus: true,
  PaperProps: {
    style: {
      padding: '16px'
    }
  }
}

const UpdateReportsModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen }
  } = useModalData({ modalType: Modals.REPORT_UPDATE_MODAL })

  const { updateReports } = React.useContext(PowerBIReportsAPIContext)

  const onFormSubmit = async (data) => {
    await updateReports(data.id)

    hideModal()
  }

  return (
    <Modal isOpen={isOpen} hideModal={hideModal} width={'xs'} {...MODAL_PROPS}>
      <Header>
        <span>Update Report</span>
        <CloseIcon right={0} onClick={hideModal} />
      </Header>
      <ReportForm onSubmit={onFormSubmit} hideModal={hideModal} />
    </Modal>
  )
}

export default UpdateReportsModal
